import { useMutation } from '@tanstack/react-query';
import { configurationService } from 'commons/services';

interface ReinitializeRpgParams {
  fiscalDocument: string;
}

interface UseReinitializeRpgAccountMutationProps {
  onSuccess?: () => void;
  onError?: () => void;
}

export function useReinitializeRpgAccountMutation({
  onSuccess,
  onError,
}: UseReinitializeRpgAccountMutationProps = {}) {
  const useMutationResult = useMutation({
    mutationFn: (params: ReinitializeRpgParams) =>
      configurationService.reinitializeRpgAccount(params),
    onError: onError,
    onSuccess: onSuccess,
  });

  return useMutationResult;
}
